// /go-link-login carries a single-use login token in the URL fragment. Take it out of
// the URL before the trackers start, so session replay never records it.
let goLinkFragment = "";

export function takeGoLinkFragment() {
  if (window.location.pathname !== "/go-link-login" || !window.location.hash)
    return;
  goLinkFragment = window.location.hash.slice(1);
  window.history.replaceState(
    window.history.state,
    "",
    window.location.pathname + window.location.search,
  );
}

export function getGoLinkFragment() {
  return goLinkFragment;
}
